import apiClient from "../../api/apiClient";
import { getTenant } from "../../utils/tenantManager";
import type { CompanyResponse, Company } from "../../models/company/CompanyModel";

// helper
const requireTenant = (): string => {
  const tenant = getTenant();
  if (!tenant) throw new Error("Tenant not selected");
  return tenant;
};

// GET PAGINATED + SEARCH
export const getCompaniesApi = async (
  search: string = "",
  pageNumber: number = 1,
  pageSize: number = 10
): Promise<CompanyResponse> => {
  const tenantId = requireTenant();

  const res = await apiClient.get("/companies", {
    params: {
      pageNumber,
      pageSize,
      search,
      tenantId,
    },
  });

  return res.data;
};

// CREATE
export const createCompanyApi = async (data: any): Promise<Company> => {
  const res = await apiClient.post(`/companies`, data);
  return res.data;
};

// GET BY ID
export const getCompanyByIdApi = async (id: string) => {
  const tenantId = requireTenant();

  const res = await apiClient.get(`/companies/${id}`, {
    params: { tenantId },
  });

  return res.data;
};

// UPDATE
export const updateCompanyApi = async (data: any) => {
  const res = await apiClient.put(`/companies`, data);
  return res.data;
};

// DELETE
export const deleteCompanyApi = async (id: string) => {
  const res = await apiClient.delete(`/companies/${id}`);
  return res.data;
};

// GET COMPANY TYPES
export const getCompanyTypesApi = async (
  pageNumber: number,
  pageSize: number,
  search: string = ""
) => {
  const tenantId = requireTenant();

  const res = await apiClient.get("/companies/types", {
    params: {
      pageNumber,
      pageSize,
      search,
      tenantId,
    },
  });

  return res.data;
};

export const getPriorityCompaniesApi = async (
  priorityCompanyId: string | null,
  page: number,
  size: number
) => {
  const tenantId = requireTenant();
  const res = await apiClient.get(
    `/companies/priority/${priorityCompanyId || ""}?PageNumber=${page}&PageSize=${size}&TenantId=${tenantId}`
  );
  return res.data;
};